<div class="main-error-page">
  <div class="error-content" [class.banner-area]="hasBanner">
    <div class="error-txt">
      <h1>{{error_header | translate}}</h1>
      <p class="sub-head">
        {{error_sub_heading_1 | translate}}
      </p>
      <p class="sub-head-2" *ngIf="error_sub_heading_2">
        {{error_sub_heading_2 | translate}}
      </p>
    </div>
    <div class="publish-btn">
      <button class="publish-button" (click)="triggerGoToMyStories()">
        <span>{{'CP_SM_GO_TO_STORIES' | translate}}</span>
        <ng-container *ngIf="showSpinner$">
            <div class="spin-in-btn">
                <div class="spinner-border spinner"></div>
            </div>
        </ng-container>
      </button>
    </div>
  </div>
  <div class="error-image">
    <picture>
      <source media="(min-width:1280px)" srcset="../../../../../assets/images/desktop-success.jpg">
      <source media="(min-width:768px)" srcset="../../../../../assets/images/desktop-success.jpg">
      <source media="(min-width:280px)" srcset="../../../../../assets/images/mobile-success.jpg">
      <img src="../../../../../assets/images/desktop-success.jpg" alt="error">
    </picture>
  </div>
</div>
